var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "text-center d-flex flex-column align-items-center justify-content-center"
    },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            "open-on-hover": "",
            disabled: !_vm.item.actions
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "div",
                    _vm._g(
                      { staticStyle: { "background-color": "white" } },
                      on
                    ),
                    [
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c(
                            "BaseButton",
                            {
                              staticStyle: { "white-space": "initial" },
                              attrs: {
                                small: "",
                                dark: _vm.isDark,
                                primary: _vm.isPrimary && !_vm.item.disabled,
                                outline:
                                  !_vm.dados[_vm.item.checked.attr] &&
                                  !_vm.item.disabled,
                                disabled: _vm.item.disabled,
                                secondary: _vm.item.disabled
                              },
                              on: {
                                click: function($event) {
                                  return _vm.goTo(_vm.item.go_to)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.item.title) + " ")]
                          ),
                          _vm.dados[_vm.item.checked.attr]
                            ? _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    color: "white",
                                    position: "absolute",
                                    right: "0px",
                                    top: "0",
                                    "text-align": "center"
                                  },
                                  attrs: { small: "" }
                                },
                                [_vm._v(" mdi-check-circle-outline ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          !_vm.hideDescription
            ? _c(
                "div",
                { staticClass: "d-flex flex-column bg-white" },
                _vm._l(_vm.item.actions, function(act) {
                  return _c(
                    "div",
                    {
                      staticClass: "m-0 mt-2",
                      staticStyle: { position: "relative" }
                    },
                    [
                      _c(
                        "BaseButton",
                        {
                          attrs: {
                            small: "",
                            dark: _vm.isDark,
                            primary: _vm.isPrimary,
                            outline: !_vm.dados[act.checked.attr]
                          }
                        },
                        [_vm._v(" " + _vm._s(act.text) + " ")]
                      ),
                      _vm.dados[act.checked.attr]
                        ? _c(
                            "v-icon",
                            {
                              staticStyle: {
                                color: "white",
                                position: "absolute",
                                right: "0px",
                                top: "0",
                                "text-align": "center"
                              },
                              attrs: { small: "" }
                            },
                            [_vm._v(" mdi-check-circle-outline ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _c(
        "v-avatar",
        {
          staticClass: "mt-1",
          attrs: { hidden: "", size: "32", color: _vm.item.color }
        },
        [
          !_vm.dados[_vm.item.checked.attr]
            ? _c("v-avatar", { attrs: { size: "28", color: "white" } })
            : _vm._e(),
          _vm.dados[_vm.item.checked.attr]
            ? _c("span", { staticClass: "white--text" }, [
                _vm._v(
                  " " + _vm._s(_vm.getInitials(_vm.item.checked.name)) + " "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      !_vm.hideDescription
        ? _c("div", { staticStyle: { height: "48px" } }, [
            _vm.dados[_vm.item.subtitle_dark.attr] ||
            _vm.item.subtitle_dark.name
              ? _c("p", { staticClass: "mb-0" }, [
                  _c("small", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dados[_vm.item.subtitle_light.attr] ||
                            _vm.item.subtitle_light.name
                        ) +
                        " "
                    )
                  ])
                ])
              : _vm._e(),
            _c("small", [
              _c("strong", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.dados[_vm.item.subtitle_dark.attr] ||
                        _vm.item.subtitle_dark.name
                    ) +
                    " "
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }